import '../Table.scss';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import chevronTable from '../../../assets/icons/chevronTable.svg';
import { USDTableType } from '../../../types';
import { useDispatch } from 'react-redux';
import { setUSDRequestScrollUtils } from '../../../store/slices/utils';

const USDRequestTable = ({ tableData, isTest, withheld }: USDTableType) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <>
      <div className={`table-container general-table general-table--usd-table`}>
        <table className="table">
          <thead className="table_head">
            <tr>
              <th className="user-id">User Id</th>
              {withheld && <th className="user-id">Amount($)</th>}
              <th className="name">User Name</th>
              <th className="email">Email Address</th>
              <th className="date">Submission Date</th>
              <th className="status">{withheld ? 'Status' : 'KYC Status'}</th>
              <th className="side-chevron"></th>
            </tr>
          </thead>
          <tbody className="table-body">
            {tableData &&
              tableData.map((val: any, index: any) => {
                return (
                  <tr
                    key={index}
                    id={val.userId}
                    className="table-row"
                    onClick={() => {
                      dispatch(
                        setUSDRequestScrollUtils({
                          scrollY: window.scrollY,
                        }),
                      );
                      navigate(`/usd-request/${val.id}/${val.user_id}?test=${isTest}`);
                    }}
                  >
                    <td className="user-id">{val.user_id}</td>
                    {withheld && <td className="user-id">$30,000</td>}
                    <td className="name">{val.user_full_name}</td>
                    <td className="email">{val.user_email}</td>
                    <td className="date">{dayjs(new Date(val.created_at)).format('D MMM YYYY, h:mm A')}</td>
                    <td
                      className={`status status--body flex--2 ${val.status.toLowerCase() === 'under review' ? 'underreview' : val.status}`}
                    >
                      <span>&#8226;</span>
                      {val.status}
                    </td>
                    <td className="side-chevron">
                      <img src={chevronTable} />
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default USDRequestTable;
